import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/fonticons': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M0 32V480H448V32H0zM167.4 228H234.8L223.7 265.3H168V378.2C168 384 166 384.9 171.2 385.5L214.7 389.6V414.7H84V389L105.3 387C110.5 386.4 112 384.7 112 379.1V267.7C112 265.4 109.1 265.4 106.2 265.4H84V228H112V207C112 157.4 138.5 137 189.3 137 223.4 137 254 145.2 254 189.8L203.3 195.9C203.6 177.2 198.9 172.9 187 172.9 168.6 172.9 168 182.8 168 200.3V223.6C168 226 164.5 228 167.4 228zM364 414.7H261.3V389.6L281.7 387C286.9 386.4 289.3 385.3 289.3 379.7V271.8C289.3 267.7 286.4 265.1 282.6 263.9L258.4 257.5 265.1 228H345.3V379.7C345.3 385.5 342.7 386.1 348.2 387L363.9 389.6V414.7zM342.1 159.2L351.1 192.4 343.8 199.7 312.6 183.1 281.4 199.7 274.1 192.4 283.1 159.2 261.3 135 264.8 125.4H292.5L308 97.4H317.3L332.8 125.4H360.5L364 135 342.1 159.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/fonticons.js
// module id = I4JZ
// module chunks = 144